module.exports = __webpack_public_path__ + "assets/img/perfect_1.07d00f72.png";